var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('dynamic-component-config-manager',{attrs:{"entry":_vm.entry}},[(_vm.entry)?_c('div',{},[(_vm.displayMode !== 'hidden')?_c('div',{staticClass:"readonly-wrapper__label",staticStyle:{"white-space":"break-spaces"}},[_vm._v(" "+_vm._s(_vm.$t(_vm.entry.name) || _vm.entry.id)+" ")]):_vm._e()]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }